//3rd Party Components
import React, { Fragment } from 'react';
import moment from 'moment';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import UAParser from 'ua-parser-js';
import { Link } from "react-router-dom";

//Components
import Heading from '../components/CASA/Heading';
import CASASpinner from '../components/Portal/CASASpinner';
import SortedTable from '../components/Portal/SortedTable';
import MetaTags from 'react-meta-tags';
import { AUcallout } from '@gov.au/callout';
import { AUformGroup } from '@gov.au/form';
import AUdirectionLink from '@gov.au/direction-links';

//Actions
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { getDownloadAROCGoogleDetails, FETCH_DOWNLOADAROCGOOGLE_SUCCESS } from '../PortalStore/Actions/DownloadAROCGoogleActions';
import { getDownloadAROCAppleDetails, FETCH_DOWNLOADAROCAPPLE_SUCCESS } from '../PortalStore/Actions/DownloadAROCAppleActions';
import { getAROCDetails, FETCH_AROCDETAILS_SUCCESS } from '../PortalStore/Actions/AROCDetailsActions';

export const ArocDetailsPage = () => {
    const [arocDetailsLoaded, setArocDetailsLoaded] = useState({ loaded: false, error: false });
    const [showSpinnerFlag, setShowSpinnerFlag] = useState(false);
    const [googleDownloadDone, setGoogleDownloadDone] = useState(false);
    const [appleDownloadDone, setAppleDownloadDone] = useState(false);
    const [iphone, setIphone] = useState(false);
    const [android, setAndroid] = useState(false);
    const [arocLoadSuccess, setArocLoadSuccess] = useState(false);

    const user = useSelector(state => state.userdetails.items?.value[0]);

    let B2CSettings = useSelector(state => state.B2CSettings.items);

    let arocDetails = useSelector(state => state.AROCDetails.items);

    const googleUrl = useSelector(state => state.DownloadAROCGoogle.items);
    const appleUrl = useSelector(state => state.DownloadAROCApple.items);

    const dispatch = useDispatch();

    var showItems = false;

    var items = [
        {
            link: '/dashind',
            text: 'myCASA'
        },
        {
            text: 'Aeronautical Radio Operator Certificate'
        }
    ];
    showItems = true;

    const isMountedRef = useRef(true);

    useEffect(() => {
        dispatch(addPageAlert({ level: '', title: '', message: '' }));

        if (!arocDetailsLoaded.loaded) {

            let parser = new UAParser();
            setIphone(parser.getDevice().model === 'iPhone' && parseFloat(parser.getOS().version) >= 8.0);
            setAndroid(parser.getOS().name === 'Android');

            axios.all([
                dispatch(getAROCDetails(B2CSettings.webappurlPortalApi, B2CSettings.accesstokenPortal, user.casa_arn)),
            ])
                .then(axios.spread((arocres) => {
                    if (isMountedRef.current) {
                        if (!(arocres.type === FETCH_AROCDETAILS_SUCCESS)) {
                            dispatch(addPageAlert({ level: 'error', title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.', message: 'Details: System error (Code: PLD.1)' }));
                        }
                        else {
                            setArocLoadSuccess(true);
                        }
                    }
                }))
                .catch(() => {
                    dispatch(addPageAlert({
                        level: 'error',
                        title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                        message: 'Details: System error (Code: PLD.2)'
                    }));
                })
                .finally(() => {
                    setArocDetailsLoaded({ loaded: true, error: false });
                });  
        }

        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (googleDownloadDone) {
            window.location.href = googleUrl.saveGooglePassUri;
        }
    }, [googleDownloadDone]);

    useEffect(() => {

        if (appleDownloadDone) {
            let reader = new FileReader();
            let blob = new Blob([appleUrl], { type: 'application/vnd.apple.pkpass' });

            reader.onloadend = function () {
                reader.fileName = 'AROC_CASA_Licence.pkpass';
                window.location.href = reader.result;
            };

            reader.readAsDataURL(blob);
        }

    }, [appleDownloadDone]);

    const getGoogleLicence = () => {
        setShowSpinnerFlag(true);

        const webappurl = B2CSettings.DigitalLicenceAPIUrl;

        axios.all([
            dispatch(getDownloadAROCGoogleDetails(webappurl, B2CSettings.accesstokenPortal, user.casa_arn))
        ])
            .then(axios.spread((drres) => {
                if (drres.type === FETCH_DOWNLOADAROCGOOGLE_SUCCESS) {
                    setGoogleDownloadDone(true);
                }
                else {
                    dispatch(addPageAlert({
                        level: 'error',
                        title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                        message: 'Details: System error (Code: DRGL.1)'
                    }));
                }
            }))
            .catch(() => {
                dispatch(addPageAlert({
                    level: 'error',
                    title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                    message: 'Details: System error (Code: DRGL.2)'
                }));
            })
            .finally(() => {
                setShowSpinnerFlag(false);
            });
    };

    const getAppleLicence = () => {
        setShowSpinnerFlag(true);

        const webappurl = B2CSettings.DigitalLicenceAPIUrl;

        axios.all([
            dispatch(getDownloadAROCAppleDetails(webappurl, B2CSettings.accesstokenPortal, user.casa_arn))
        ])
            .then(axios.spread((drres) => {
                if (drres.type === FETCH_DOWNLOADAROCAPPLE_SUCCESS) {
                    setAppleDownloadDone(true);
                }
                else {
                    dispatch(addPageAlert({
                        level: 'error',
                        title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                        message: 'Details: System error (Code: DRAL.1)'
                    }));
                }
            }))
            .catch(function () {
                dispatch(addPageAlert({
                    level: 'error',
                    title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                    message: 'Details: System error (Code: DRAL.2)'
                }));
            })
            .finally(() => {
                setShowSpinnerFlag(false);
            });
    };

    const showSpinner = () => {
        if (showSpinnerFlag) {
            return <CASASpinner message='Working. Please wait.....' />;
        }
    };

    const addBadge = (row, column) => {
        if (row["status"] != "Active" && column.property == "status") {
            return  "badge badge-expired";
        }
    };

    const showCertificateHolderDetails = () => {
        let certificateHolderArr = [];
        let caption = 'Certificate holder details';
        let certificateHolderCols = [
            {
                'label': 'Name',
                'property': 'name',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '40%'
            },
            {
                'label': user.fullname,
                'property': 'value',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '60%'
            },
            {
                'label': 'Id',
                'property': 'id',
                'visible': false,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '0%'
            }
        ];

        let dob = moment(user.birthdate, 'YYYY-MM-DD').format('DD MMM YYYY')

        let row1 = { 'name': 'ARN and certificate number', 'value': user.casa_arn, 'id': '1' };
        let row2 = { 'name': 'Date of birth', 'value': dob, 'id': '2' };
        let row3 = { 'name': 'Nationality', 'value': user['nationality.casa_name'], 'id': '3' };

        certificateHolderArr.push(row1);
        certificateHolderArr.push(row2);
        certificateHolderArr.push(row3);

        return (
            <div>
                <SortedTable
                    data={certificateHolderArr}
                    cols={certificateHolderCols}
                    caption={caption}
                    sortby="id"
                    cellClasser={addBadge}
                    ignoreSortByColumn={true}
                />
            </div>
        );
    };

    
    const showCertificateDetails = () => {
        let certificateDetailsArr = [];
        let caption = 'Certificate details';
        let certificateDetailsCols = [
            {
                'label': 'Certificate type',
                'property': 'certificateType',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '90%'
            },
            {
                'label': 'Issue date',
                'property': 'issueDate',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '10%'
            }
        ];
        
        let issueDate = moment(arocDetails.acquisitionDate, 'YYYY-MM-DD').format('DD/MM/YYYY')

        let row1 = { 'certificateType': 'Aeronautical Radio Operator Certificate', 'issueDate': issueDate };

        certificateDetailsArr.push(row1);

        return (
            <div>
                <SortedTable
                    data={certificateDetailsArr}
                    cols={certificateDetailsCols}
                    caption={caption}
                    cellClasser={addBadge}
                    ignoreSortByColumn={true}
                />
            </div>
        );
    };

    const showElp = () => {
        let elpDetailsArr = [];
        let caption = 'English language proficiency';
        let elpDetailsCols = [];


        if(arocDetails.elpRemark){
            elpDetailsCols = [{
                'label': 'Proficiency type',
                'property': 'proficiencyType',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '100%'
            }
        ];

        elpDetailsArr.push({ 'proficiencyType': arocDetails.elpRemark });
        }
        else if(arocDetails.proficiencies && arocDetails.proficiencies.length > 0){
            elpDetailsCols = [{
                'label': 'Proficiency type',
                'property': 'proficiencyType',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '90%'
            },
            {
                'label': 'Valid To',
                'property': 'validTo',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '10%'
            }
            ];

            for (let i = 0; i < arocDetails.proficiencies.length; i++) {
                let item = {
                    'proficiencyType': `AELP level ${arocDetails.proficiencies[i].result}`,
                    'validTo': arocDetails.proficiencies[i].validUntil ? moment(arocDetails.proficiencies[i].validUntil, 'YYYY-MM-DD').format('DD/MM/YYYY') : 'N/A'
                };
                elpDetailsArr.push(item);
            }
        }

        return (
            <div>
                <SortedTable
                    data={elpDetailsArr}
                    cols={elpDetailsCols}
                    caption={caption}
                    cellClasser={addBadge}
                    ignoreSortByColumn={true}
                />
            </div>
        );
    };

    const displayDigitalLicenceAppleBtn = () => {
        return (
            <p>
                <img src='/forms/images/Add_to_Apple_Wallet_rgb_US-UK.svg' style={{ width: '100%' }} onClick={getAppleLicence} alt='Add to Apple Wallet'/>
            </p>
        );
    };

    const displayDigitalLicenceGoogleBtn = () => {
        return (
            <p>
                <img src='/forms/images/enAU_add_to_google_wallet_wallet-button.svg' style={{ width: '100%' }} onClick={getGoogleLicence} alt='Adds to Google Wallet'/>
            </p>
        );
    };

    const showDownloadHelpText = () => {
        return (
            <AUcallout title='Download your digital certificate'>
                <span>
                    You can now download a digital version of your Aeronautical Radio Operator Certificate on your mobile device for domestic use only.
                </span>
            </AUcallout>
        );
    };

    const showDownloadHelpTextMobile = () => {
        return (
            <AUcallout title='Download your digital certificate'>
                <span>
                    Note that by adding the digital certificate to your {iphone ? "Apple" : android ? "Google" : ""} Wallet, you are consenting to your details being confirmed through the QR code on the front of the digital certificate to anyone you show the digital certificate to.
                </span>
                {iphone && displayDigitalLicenceAppleBtn()}
                {android && displayDigitalLicenceGoogleBtn()}
            </AUcallout>
        );
    };

    if (!arocDetailsLoaded.loaded) {
        return (
            <CASASpinner message='Loading. Please wait...' />
        );
    }
    else {
        return (
            <Fragment>
                <div style={{ minHeight: '800px' }}>
                    <MetaTags title='Aeronautical Radio Operator Certificate'></MetaTags>

                    <Heading
                        text='Aeronautical Radio Operator Certificate'
                        breadcrumbs={items}
                        showcrumbs={showItems}
                        showback={false} />

                    {/*link back*/}
                    <AUformGroup>
                        <AUdirectionLink link='/dashind' text='Back' direction='left' style={{ marginTop: '10px' }} />
                    </AUformGroup>

                    <br/>
         
                    {showSpinner()}

                    {!iphone && !android ? showDownloadHelpText() : showDownloadHelpTextMobile()}

                    {/*certificate holder details*/}
                    {arocLoadSuccess && showCertificateHolderDetails()}

                    {/*certificate details*/}
                    {arocLoadSuccess && showCertificateDetails()}

                    {/*English language proficiency*/}
                    {arocLoadSuccess && showElp()}

                    {/*link back*/}
                    <AUformGroup>
                        <AUdirectionLink link='/dashind' text='Return to myCASA' direction='left' style={{ marginTop: '50px' }} />
                    </AUformGroup>
                </div>
            </Fragment>
        );
    }
};
